import { render, staticRenderFns } from "./JSelectBizComponentModal.vue?vue&type=template&id=9214f856&scoped=true&"
import script from "./JSelectBizComponentModal.vue?vue&type=script&lang=js&"
export * from "./JSelectBizComponentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9214f856",
  null
  
)

export default component.exports